var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { colors, cssVarsThemed, typographyCss } from '@creditornot/cb-ingredients';
import { createCssVars } from '@creditornot/cb-utils';
import InputRadio from './InputRadio';
var colorCssVars = createCssVars(['label', 'labelActive']);
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  display: inline-block;\n  position: relative;\n"], ["\n  ", "\n\n  display: inline-block;\n  position: relative;\n"])), cssVarsThemed({
    label: {
        light: colors.pepper100,
        dark: colors.salt100,
    },
    labelActive: {
        light: colors.pepper80,
        dark: colors.salt80,
    },
}));
var TextLabel = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n"], ["\n  ", "\n  color: ", ";\n"])), typographyCss.Body3, colorCssVars.label);
var Label = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  &:active ", " {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  &:active ", " {\n    color: ", ";\n  }\n"])), TextLabel, colorCssVars.labelActive);
var Content = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-inline-start: 8px;\n"], ["\n  margin-inline-start: 8px;\n"])));
/**
 * This is the default radio component to be used. It renders both
 * the input itself and the associated label. If you need only the input,
 * you should use `InputRadio` instead.
 */
var Radio = React.forwardRef(function (_a, ref) {
    var checked = _a.checked, children = _a.children, className = _a.className, disabled = _a.disabled, inputProps = _a.inputProps, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onClick = _a.onClick, onFocus = _a.onFocus, readOnly = _a.readOnly, required = _a.required, rootRef = _a.rootRef, style = _a.style, value = _a.value;
    return (React.createElement(Root, { className: className, ref: rootRef, style: style },
        React.createElement(Label, null,
            React.createElement(InputRadio, __assign({}, inputProps, { checked: checked, disabled: disabled, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, readOnly: readOnly, ref: ref, required: required, value: value })),
            children !== undefined && (React.createElement(Content, null, typeof children === 'string' ? React.createElement(TextLabel, null, children) : children)))));
});
Radio.displayName = 'Radio';
export default Radio;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Radio.js.map